exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cell-placeholder[data-v-34cf0d9a]{text-align:center;font-size:14px;margin-top:16px;font-weight:400;color:#91969d}.sidebar-helptext[data-v-34cf0d9a]{font-size:14px;font-weight:400;color:#c6c6c6;margin:0}.scroll[data-v-34cf0d9a]::-webkit-scrollbar{width:4px}.scroll[data-v-34cf0d9a]::-webkit-scrollbar-track{background:#c6c6c6}.scroll[data-v-34cf0d9a]::-webkit-scrollbar-thumb{background:#91969d;border-radius:4px}.scroll[data-v-34cf0d9a]::-webkit-scrollbar-thumb:hover{background:#767c85}.info-text[data-v-34cf0d9a]{line-height:21px}.ui-button.keep-it-btn[data-v-34cf0d9a]{margin-left:16px}", ""]);

// exports
